import React, { useState, useEffect } from 'react';
import { Card, Col, Row, Form, Button, Spinner, FloatingLabel, OverlayTrigger, Tooltip } from 'react-bootstrap';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import PageHeader from 'components/common/PageHeader';
import { InputGroup } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import { components } from "react-select";
import { useSearchParams } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import IconAlert from 'components/common/IconAlert';
import $ from 'jquery';
import DeleteItemModal from 'components/modalComponents/deleteItemModal';
import UploadFormFiles from 'components/common/UploadFormFiles';
import { useNavigate } from "react-router-dom";
import axiosInstance from 'helpers/axiosInstance';
import DatePicker, { registerLocale } from 'react-datepicker';

const { ValueContainer, Placeholder } = components;


const EditClientForm = () => {
    let form = '';
    const [validated, setValidated] = useState(false);

    const [isTestDisabled, setIsTestDisabled] = useState(false);


    const [searchParams, setSearchParams] = useSearchParams();
    const [attachmentsData, setAttachmentsData] = useState({ data: [] });
    const [attachmentKind, setAttachmentKind] = useState({ data: [] });

    const [physMet, setPhysMet] = useState(false);
    const [activeClient, setActiveClient] = useState(false);
    const [PEP, setPEP] = useState(false);
    const [specialTransac, setSpecialTransac] = useState(false);
    const [selectedNationality, setSelectedNationality] = useState(null);
    const [selectedResidence, setSelectedResidence] = useState(null);

    const [selectedOption, setSelectedOption] = useState('');
    const [nationalityOptions, setNationalityOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState({
        charter: false,
        sale: false
    });
    const [isLoadingNationalities, setIsLoadingNationalities] = useState(true);

    const [kycErrorShown, setKycErrorShown] = useState(false);

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setSelectedOptions(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const [formData, setFormData] = useState({
        id: 0,
        company: '',
        nationalite: '',
        nationality: '',
        nationalityId: null,
        countryResidence: '',
        countryResidenceId: null,
        name: '',
        IBAN: '',
        SWIFT: '',
        address: '',
        bankAddress: '',
        kyc: false,
        notes: '',
        Risk: '',
        activeClient: false,
        physMet: false,
        PEP: false,
        specialTransac: false,
        NatureRelationshipCharter: false,
        NatureRelationshipSale: false,
        dateNextCheck: '',
        dateCheckedOn: '',
        ComplianceComment: ''
    });

    const CustomValueContainer = ({ children, ...props }) => {
        return (
            <ValueContainer {...props}>
                <Placeholder {...props} isFocused={props.isFocused}>
                    {props.selectProps.placeholder}
                </Placeholder>
                {React.Children.map(children, (child) =>
                    child && child.type !== Placeholder ? child : null
                )}
            </ValueContainer>
        );
    };

    const handleChange = (e) => {
        setSelectedOption(e.target.value);
    };

    const loadOptionsFromCache = (inputValue) => {
        return Promise.resolve(
            nationalityOptions.filter(option =>
                option.residentName.toLowerCase().includes(inputValue.toLowerCase())
                || option.countryName.toLowerCase().includes(inputValue.toLowerCase())
            )
        );
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoadingNationalities(true);
                const nationalitiesResponse = await axiosInstance.get(`${window.location.origin}/parameters/countries`);
                setNationalityOptions(nationalitiesResponse.data);
                setIsLoadingNationalities(false);

                setFormData({ ...formData, ["id"]: searchParams.get("id") });

                const [filesResponse, clientResponse] = await Promise.all([
                    axiosInstance.get(`${window.location.origin}/uploadFiles/GetFiles?FilesFrom=${"client-" + searchParams.get("id")}`),
                    axiosInstance.get(`${window.location.origin}/clients/${searchParams.get("id")}`)
                ]);

                axiosInstance.get(`${window.location.origin}/parameters`).then((res) => {
                    setAttachmentKind({ data: res.data.attachmentKinds.values });
                });

                setAttachmentsData({ data: filesResponse.data });

                if (clientResponse.data !== null) {
                    const nextCheck = clientResponse.data.dateNextCheck ? new Date(clientResponse.data.dateNextCheck) : null;
                    const checkedOn = clientResponse.data.dateCheckedOn ? new Date(clientResponse.data.dateCheckedOn) : null;


                    if (checkedOn) {
                        checkedOn.setHours(12, 0, 0, 0);
                    }

                    const selectedNationalityOption = nationalitiesResponse.data.find(
                        opt => opt.id === clientResponse.data.nationalityId
                    );
                    const selectedResidenceOption = nationalitiesResponse.data.find(
                        opt => opt.id === clientResponse.data.countryResidenceId
                    );

                    setSelectedNationality(selectedNationalityOption || null);
                    setSelectedResidence(selectedResidenceOption || null);

                    var KYC_validated = clientResponse.data.KYC;
                    if (nextCheck) {
                        nextCheck.setHours(12, 0, 0, 0);
                        if (!kycErrorShown) {
                            const today = new Date();
                            today.setHours(12, 0, 0, 0);
                            if (clientResponse.data.KYC && nextCheck < today) {
                                //toast.error(`KYC was valid for ${clientResponse.data.Name}, however the 'Next documents check' date has passed.`, {
                                //    theme: 'colored', autoClose: 7000
                                //});
                                KYC_validated = false;
                                setKycErrorShown(true);
                            }
                        }
                    }

                    setFormData({
                        id: clientResponse.data.Id,
                        company: clientResponse.data.Company,
                        name: clientResponse.data.Name,
                        nationalite: clientResponse.data.Nationalite,
                        IBAN: clientResponse.data.IBAN,
                        SWIFT: clientResponse.data.SWIFT,
                        address: clientResponse.data.Address,
                        bankAddress: clientResponse.data.BankAddress,
                        kyc: KYC_validated,
                        notes: clientResponse.data.Notes,
                        countryResidenceId: clientResponse.data.countryResidenceId,
                        nationalityId: clientResponse.data.nationalityId,
                        activeClient: clientResponse.data.ActiveClient,
                        physMet: clientResponse.data.PhysMet,
                        PEP: clientResponse.data.PEP,
                        specialTransac: clientResponse.data.SpecialTransac,
                        Risk: clientResponse.data.Risk,
                        NatureRelationshipSale: clientResponse.data.NatureRelationshipSale,
                        NatureRelationshipCharter: clientResponse.data.NatureRelationshipCharter,
                        dateNextCheck: nextCheck,
                        dateCheckedOn: checkedOn,
                        ComplianceComment: clientResponse.data.ComplianceComment,
                    });




                } else {
                    toast.error(`No Client found`, {
                        theme: 'colored'
                    });
                }

            } catch (error) {
                console.error('Error loading data:', error);
                toast.error('Error loading data', { theme: 'colored' });
            }
        };

        fetchData();
    }, []); // Empty dependency array - runs once on mount

    //Handlers
    let navigate = useNavigate();

    const handleExit = (e) => {
        navigate("/components/clients");
    }

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        console.log(formData);

        if (form.checkValidity() === false) {
            toast.error('Please fill in all required fields with valid information. (Required fields are outlined in red.)', {
                theme: 'colored'
            });
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            // formData["attachments"] = attachmentsData.data;
            axiosInstance.post(`${window.location.origin}/clients`, formData)
                .then((res) => {
                    if (res.data.id !== '0') {
                        navigate("/components/clients");
                        toast.success(`Client information has been modified.`, {
                            theme: 'colored'
                        });
                        formData.id = res.data.id;

                    } else {
                        toast.error(`${res.data.message}`, {
                            theme: 'colored'
                        });
                    }

                    $('.save-spinner').attr('hidden', 'hidden');
                });
        }
        setValidated(true);
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });
    };

    const handleDelete = (e) => {
        axiosInstance.delete(`${window.location.origin}/clients/${searchParams.get("id")}`)
            .then((res) => {
                navigate("/components/clients");
                toast.success(`Client has been deleted.`, {
                    theme: 'colored'
                });
                $('.save-spinner').attr('hidden', 'hidden');
            });
    }

    const getDateColor = (nextCheck) => {
        if (!nextCheck || !(nextCheck instanceof Date)) return '';

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const oneMonthFromNow = new Date(today);
        oneMonthFromNow.setMonth(today.getMonth() + 1);

        const nextCheckDate = new Date(nextCheck);
        nextCheckDate.setHours(0, 0, 0, 0);

        if (nextCheckDate < today) {
            return ' text-danger input-danger';
        } else if (nextCheckDate <= oneMonthFromNow) {
            return ' text-warning input-warning';
        }
        return '';
    };

    const getKYCStatus = (kyc, nextCheck) => {
        if (!nextCheck || !(nextCheck instanceof Date)) return kyc;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const nextCheckDate = new Date(nextCheck);
        nextCheckDate.setHours(0, 0, 0, 0);
        return kyc && nextCheckDate >= today;
    };

    const calculateNextCheckDate = (checkedOnDate, riskLevel) => {
        if (!checkedOnDate) return null;

        const nextDate = new Date(checkedOnDate);
        nextDate.setHours(12, 0, 0, 0);

        const today = new Date();
        today.setHours(12, 0, 0, 0);

        switch (riskLevel) {
            case 'High':
                nextDate.setFullYear(nextDate.getFullYear() + 1);
                break;
            case 'Standard':
                nextDate.setFullYear(nextDate.getFullYear() + 2);
                break;
            case 'Low':
                nextDate.setFullYear(nextDate.getFullYear() + 3);
                break;
            default:
                return null;
        }

        //if (nextDate < today) {
        //    setFormData({ ...formData, kyc: false });
        //}

        return nextDate;
    };

    return (
        <>
            <PageHeader className="mb-3 g-3" title="">
                <div className="d-inline">
                    <h3 className="float-start">Edit client information</h3>
                    <div className="float-end">
                        <Button
                            variant='falcon-primary'
                            className='me-2'
                            type="submit"
                            onClick={e => form.dispatchEvent(
                                new Event("submit", { cancelable: true, bubbles: true })
                            )}
                        >
                            <Spinner animation="border" variant="primary" size="sm" hidden={true} className="save-spinner" />
                            Save</Button>
                        <Button
                            variant='falcon-warning'
                            className='me-2'
                            onClick={handleExit}
                        >
                            <Spinner animation="border" variant="warning" role="status" size="sm" hidden={true} className="cancel-spinner" />
                            Cancel</Button>

                        <DeleteItemModal item="Client" itemName={formData.name} function={handleDelete} />
                    </div>
                </div>
            </PageHeader>

            <Row className="mb-3 g-3">
                <Col lg={12}>
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5>Client Details</h5>
                        </Card.Header>
                        <Card.Body className="bg-light">
                            <Form validated={validated} onSubmit={handleSubmit} ref={ref => form = ref}>
                                <Row className="g-3">
                                    <FloatingLabel as={Col} lg={8}
                                        controlId="name"
                                        label="Client name"
                                    >
                                        <Form.Control
                                            type="text"
                                            value={formData.name}
                                            onChange={handleFieldChange}
                                            placeholder="Name"
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter a client name.
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                    <Form.Group as={Col} lg={4}>
                                        <InputGroup className="h-100">
                                            <AsyncSelect
                                                isClearable={true}
                                                getOptionLabel={option => option.residentName}
                                                getOptionValue={option => option.id}
                                                value={selectedNationality}
                                                className="h-100 w-100 flex-fill w-50 fs--1rem"
                                                placeholder="Client nationality"
                                                loadOptions={loadOptionsFromCache}
                                                isLoading={isLoadingNationalities}
                                                defaultOptions={nationalityOptions}
                                                classNamePrefix="selectCustomFont"
                                                onChange={(selectedOption) => {
                                                    setSelectedNationality(selectedOption);
                                                    setFormData({
                                                        ...formData,
                                                        nationalityId: selectedOption ? selectedOption.id : null
                                                    });
                                                }}
                                                components={{
                                                    ValueContainer: CustomValueContainer
                                                }}
                                                styles={{
                                                    container: (baseStyles) => ({
                                                        ...baseStyles,
                                                    }),
                                                    valueContainer: (provided, state) => ({
                                                        ...provided,
                                                        overflow: "visible"
                                                    }),
                                                    control: (baseStyles) => ({
                                                        ...baseStyles,
                                                        height: '100%',
                                                    }),
                                                    menuList: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: 'white',
                                                    }),
                                                    placeholder: (provided, state) => ({
                                                        ...provided,
                                                        position: "absolute",
                                                        top: state.hasValue || state.selectProps.inputValue ? -10 : null,
                                                        backgroundColor:
                                                            state.hasValue || state.selectProps.inputValue
                                                                ? "transparent"
                                                                : "transparent",
                                                        transition: "top 0.1s, font-size 0.1s",
                                                        fontSize: state.hasValue || state.selectProps.inputValue ? 11.5 : 13,
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        transform: 'translateY(8px)'
                                                    }),
                                                    input: (base, state) => ({
                                                        ...base,
                                                        transform: state.hasValue || state.selectProps.inputValue ? 'translateY(8px)' : null
                                                    }),

                                                }}
                                            >
                                            </AsyncSelect>
                                        </InputGroup>
                                    </Form.Group>

                                    <FloatingLabel as={Col} lg={8}
                                        controlId="address"
                                        label="Client address"
                                    >
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            value={formData.address}
                                            onChange={handleFieldChange}
                                            placeholder="Address"
                                        />
                                    </FloatingLabel>
                                    <Form.Group as={Col} lg={4}>
                                        <InputGroup className="h-100">
                                            <AsyncSelect
                                                isClearable={true}
                                                getOptionLabel={option => option.countryName}
                                                getOptionValue={option => option.id}
                                                value={selectedResidence}
                                                className="h-100 w-100 flex-fill w-50 fs--1rem"
                                                placeholder="Client country of residence"
                                                loadOptions={loadOptionsFromCache}
                                                isLoading={isLoadingNationalities}
                                                defaultOptions={nationalityOptions}
                                                onChange={(selectedOption) => {
                                                    setSelectedResidence(selectedOption);
                                                    setFormData({
                                                        ...formData,
                                                        countryResidenceId: selectedOption ? selectedOption.id : null
                                                    });
                                                }}
                                                classNamePrefix="selectCustomFont"
                                                components={{
                                                    ValueContainer: CustomValueContainer
                                                }}
                                                styles={{
                                                    container: (baseStyles) => ({
                                                        ...baseStyles,
                                                    }),
                                                    valueContainer: (provided, state) => ({
                                                        ...provided,
                                                        overflow: "visible"
                                                    }),
                                                    control: (baseStyles) => ({
                                                        ...baseStyles,
                                                        height: '100%',
                                                    }),
                                                    menuList: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: 'white',
                                                    }),
                                                    placeholder: (provided, state) => ({
                                                        ...provided,
                                                        position: "absolute",
                                                        top: state.hasValue || state.selectProps.inputValue ? -10 : null,
                                                        backgroundColor:
                                                            state.hasValue || state.selectProps.inputValue
                                                                ? "transparent"
                                                                : "transparent",
                                                        transition: "top 0.1s, font-size 0.1s",
                                                        fontSize: state.hasValue || state.selectProps.inputValue ? 11.5 : 13,
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        transform: 'translateY(8px)'
                                                    }),
                                                    input: (base, state) => ({
                                                        ...base,
                                                        transform: state.hasValue || state.selectProps.inputValue ? 'translateY(8px)' : null
                                                    }),

                                                }}

                                            >
                                            </AsyncSelect>
                                        </InputGroup>
                                    </Form.Group>
                                    <FloatingLabel as={Col} lg={8}
                                        controlId="IBAN"
                                        label="IBAN"
                                    >
                                        <Form.Control
                                            type="text"
                                            value={formData.IBAN}
                                            onChange={handleFieldChange}
                                            placeholder="IBAN"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter a client IBAN.
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                    <FloatingLabel as={Col} lg={4}
                                        controlId="SWIFT"
                                        label="SWIFT"
                                    >
                                        <Form.Control
                                            type="text"
                                            value={formData.SWIFT}
                                            onChange={handleFieldChange}
                                            placeholder="SWIFT"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter a client SWIFT code.
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                    <FloatingLabel as={Col} lg={12}
                                        controlId="bankAddress"
                                        label="Bank address"
                                    >
                                        <Form.Control
                                            as="textarea"
                                            value={formData.bankAddress}
                                            onChange={handleFieldChange}
                                            placeholder="Bank address"
                                        />
                                    </FloatingLabel>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={12}>
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5>Compliance</h5>
                            <div className='d-flex'>
                                <Form.Group as={Col} lg={4} className="mt-0">
                                    <div className="position-relative d-inline-block">
                                        {getKYCStatus(true, formData.dateNextCheck) ? (
                                            <BootstrapSwitchButton
                                                type='switch'
                                                id='kyc'
                                                onlabel='KYC'
                                                offlabel='KYC'
                                                onstyle="primary"
                                                offstyle="light"
                                                width="100"
                                                checked={formData.kyc}
                                                onChange={(e) => {
                                                    setFormData({ ...formData, "kyc": e });
                                                }}
                                            />
                                        ) : (
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="kyc-disabled-tooltip">
                                                        The KYC button is disabled because the 'Next documents check' date has passed.
                                                        Please update the documents and check dates to re-enable KYC.
                                                    </Tooltip>
                                                }
                                            >
                                                <div className="disabled-switch-wrapper">
                                                    <BootstrapSwitchButton
                                                        type='switch'
                                                        id='kyc-disabled'
                                                        onlabel='KYC'
                                                        offlabel='KYC'
                                                        onstyle="primary"
                                                        offstyle="light"
                                                        width="100"
                                                        checked={false}
                                                        onChange={() => { }}
                                                        style={{ opacity: 0.5, cursor: 'not-allowed' }}
                                                    />

                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            right: 0,
                                                            bottom: 0,
                                                            zIndex: 0,
                                                            background: '#c7c6c68c',
                                                            cursor: 'not-allowed'
                                                        }}
                                                    />
                                                </div>
                                            </OverlayTrigger>
                                        )}
                                    </div>
                                </Form.Group>
                            </div>
                        </Card.Header>
                        <Card.Body className="bg-light">
                            <Form validated={validated} onSubmit={handleSubmit} ref={ref => form = ref}>
                                <Row className="g-3 mx-3">
                                    <div className="col-5 d-flex flex-row mb-1 justify-content-between">
                                        <h6 className="mb-0">Active client</h6>
                                        <div className="d-flex">
                                            <Form.Check
                                                style={{ height: "1.5rem" }}
                                                type='switch'
                                                id='activeClient'
                                                className="mb-0"
                                                label={formData.activeClient ? 'Yes' : 'No'}
                                                checked={formData.activeClient}
                                                onChange={(e) => {
                                                    setActiveClient(e.target.checked);
                                                    setFormData({ ...formData, "activeClient": e.target.checked });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Row>
                                <Row className="g-3 mx-3">
                                    <div className="col-5 d-flex flex-row mb-1 justify-content-between">
                                        <h6 className="mb-0">Physically met</h6>
                                        <div className="d-flex">
                                            <Form.Check
                                                style={{ height: "1.5rem" }}
                                                type='switch'
                                                id='physMet'
                                                className="mb-0"
                                                label={formData.physMet ? 'Yes' : 'No'}
                                                checked={formData.physMet}
                                                onChange={(e) => {
                                                    setPhysMet(e.target.checked);
                                                    setFormData({ ...formData, "physMet": e.target.checked });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Row>
                                <Row className="g-3 mx-3">
                                    <div className="col-5 d-flex flex-row mb-1 justify-content-between">
                                        <h6 className="mb-0">PEP</h6>
                                        <div className="d-flex">
                                            <Form.Check
                                                style={{ height: "1.5rem" }}
                                                type='switch'
                                                id='PEP'
                                                className="mb-0"
                                                label={formData.PEP ? 'Yes' : 'No'}
                                                checked={formData.PEP}
                                                onChange={(e) => {
                                                    setPEP(e.target.checked);
                                                    setFormData({ ...formData, "PEP": e.target.checked });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Row>
                                <Row className="g-3 mx-3">
                                    <div className="col-5 d-flex flex-row mb-1 justify-content-between">
                                        <h6 className="mb-0">Special transaction deep examination</h6>
                                        <div className="d-flex">
                                            <Form.Check
                                                style={{ height: "1.5rem" }}
                                                type='switch'
                                                id='specialTransac'
                                                className="mb-0"
                                                label={formData.specialTransac ? 'Yes' : 'No'}
                                                checked={formData.specialTransac}
                                                onChange={(e) => {
                                                    setSpecialTransac(e.target.checked);
                                                    setFormData({ ...formData, "specialTransac": e.target.checked });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Row>
                                <div className="border-bottom border-dashed my-3"></div>
                                <Row>
                                    <div className="col-lg-8 col-sm-12">
                                        <Row className="g-3 mx-3">
                                            <div className="col-6">
                                                <fieldset>
                                                    <Form.Group as={Row} className="mb-3">
                                                        <Form.Label as="legend" className="h6 pt-0" column sm={2}>
                                                            Risk
                                                        </Form.Label>
                                                        <Col sm={10}>
                                                            <Form.Check
                                                                type="radio"
                                                                label="Low"
                                                                name="formHorizontalRadios"
                                                                id="formHorizontalRadios1"
                                                                checked={formData.Risk === "Low"}
                                                                onChange={(e) => {
                                                                    const nextCheckDate = calculateNextCheckDate(formData.dateCheckedOn, "Low");
                                                                    setFormData({
                                                                        ...formData,
                                                                        Risk: "Low",
                                                                        dateNextCheck: nextCheckDate
                                                                    });
                                                                }}
                                                            />
                                                            <Form.Check
                                                                type="radio"
                                                                label="Standard"
                                                                name="formHorizontalRadios"
                                                                id="formHorizontalRadios2"
                                                                checked={formData.Risk === "Standard"}
                                                                onChange={(e) => {
                                                                    const nextCheckDate = calculateNextCheckDate(formData.dateCheckedOn, "Standard");
                                                                    setFormData({
                                                                        ...formData,
                                                                        Risk: "Standard",
                                                                        dateNextCheck: nextCheckDate
                                                                    });
                                                                }}
                                                            />
                                                            <Form.Check
                                                                type="radio"
                                                                label="High"
                                                                name="formHorizontalRadios"
                                                                id="formHorizontalRadios3"
                                                                checked={formData.Risk === "High"}
                                                                onChange={(e) => {
                                                                    const nextCheckDate = calculateNextCheckDate(formData.dateCheckedOn, "High");
                                                                    setFormData({
                                                                        ...formData,
                                                                        Risk: "High",
                                                                        dateNextCheck: nextCheckDate
                                                                    });
                                                                }}
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                </fieldset>
                                            </div>
                                            <div className="col-6">
                                                <fieldset>
                                                    <Form.Group as={Row} className="mb-3">
                                                        <Form.Label as="legend" className="h6 pt-0" column>
                                                            Nature of relationship
                                                        </Form.Label>
                                                        <Col >
                                                            <Form.Check
                                                                type="checkbox"
                                                                label="Charter"
                                                                id='charterCheck'
                                                                aria-labelledby="charterCheck"
                                                                checked={formData.NatureRelationshipCharter}
                                                                onChange={(e) => {
                                                                    setFormData({ ...formData, "NatureRelationshipCharter": e.target.checked });
                                                                }}
                                                            />
                                                            <Form.Check
                                                                type="checkbox"
                                                                label="Sale"
                                                                id='SaleCheck'
                                                                aria-labelledby="SaleCheck"
                                                                checked={formData.NatureRelationshipSale}
                                                                onChange={(e) => {
                                                                    setFormData({ ...formData, "NatureRelationshipSale": e.target.checked });
                                                                }}
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                </fieldset>
                                            </div>

                                        </Row>
                                        <Row className="g-3 mx-3 pt-1">
                                            <div className="col-6">
                                                <div className="row">
                                                    <div className="">
                                                        <label className="h6">Documents checked on</label>
                                                        <DatePicker
                                                            autoComplete='off'
                                                            selected={formData.dateCheckedOn}
                                                            onChange={(date) => {
                                                                if (date) {
                                                                    date.setHours(12, 0, 0, 0);
                                                                    const nextCheckDate = calculateNextCheckDate(date, formData.Risk);
                                                                    setFormData({
                                                                        ...formData,
                                                                        dateCheckedOn: date,
                                                                        dateNextCheck: nextCheckDate
                                                                    });
                                                                } else {
                                                                    setFormData({
                                                                        ...formData,
                                                                        dateCheckedOn: null,
                                                                        dateNextCheck: null
                                                                    });
                                                                }
                                                            }}
                                                            maxDate={new Date()}
                                                            formatWeekDay={day => day.slice(0, 3)}
                                                            className='form-control unsetWidth'
                                                            value={formData.dateCheckedOn}
                                                            name="dateCheckedOn"
                                                            timeIntervals={5}
                                                            dateFormat="dd/MM/yyyy"
                                                            locale='es'
                                                            placeholderText="dd/mm/yy"
                                                            portalId="root-portal"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="row">
                                                    <div className="">
                                                        <label className={`h6 ${getDateColor(formData.dateNextCheck)}`}>Next documents check</label>
                                                        {/*<OverlayTrigger*/}
                                                        {/*    placement="left-start"*/}
                                                        {/*    overlay={*/}
                                                        {/*        <Tooltip>*/}
                                                        {/*            This field is automatically calculated based on:<br />*/}
                                                        {/*            • 'Documents checked on' date<br />*/}
                                                        {/*            • 'Risk' level selected:<br />*/}
                                                        {/*            &nbsp;&nbsp;Low = +3 years<br />*/}
                                                        {/*            &nbsp;&nbsp;Standard = +2 years<br />*/}
                                                        {/*            &nbsp;&nbsp;High = +1 year<br />*/}
                                                        {/*            (This field may also be manually adjusted if needed. Date cannot be set prior to the current day.)*/}
                                                        {/*        </Tooltip>*/}
                                                        {/*    }*/}
                                                        {/*    trigger={['focus']}*/}
                                                        {/*>*/}
                                                        <DatePicker
                                                            autoComplete='off'
                                                            selected={formData.dateNextCheck}
                                                            onChange={(date) => {
                                                                if (date) {
                                                                    date.setHours(12, 0, 0, 0);
                                                                }
                                                                setFormData({ ...formData, dateNextCheck: date });
                                                            }}
                                                            formatWeekDay={day => day.slice(0, 3)}
                                                            className={`form-control unsetWidth ${getDateColor(formData.dateNextCheck)}`}
                                                            value={formData.dateNextCheck}
                                                            minDate={new Date()}
                                                            name="dateNextCheck"
                                                            timeIntervals={5}
                                                            dateFormat="dd/MM/yyyy"
                                                            locale='es'
                                                            placeholderText="dd/mm/yy"
                                                            portalId="root-portal"
                                                        />
                                                        {/*</OverlayTrigger>*/}
                                                    </div>
                                                </div>
                                            </div>
                                        </Row>
                                    </div>
                                    <div className="col-lg-4 col-sm-8 ps-lg-0 mt-sm-4 mt-lg-0">
                                        <div className="col-12">
                                            <IconAlert variant={"info"} className='mb-2'>
                                                <p className="mb-2" >The 'Next documents check' date is automatically calculated based on:</p>
                                                <p className="mb-3 ms-3">• 'Documents checked on' date<br />
                                                    • 'Risk' level selected:<br />
                                                    <p className="mb-0 ms-4">&nbsp;&nbsp;Low = +3 years</p>
                                                    <p className="mb-0 ms-4">&nbsp;&nbsp;Standard = +2 years</p>
                                                    <p className="mb-0 ms-4">&nbsp;&nbsp;High = +1 year</p></p>
                                                <p className="mb-0 font-italic font-weight-light" style={{ fontSize: "smaller", fontStyle: "italic" }}>
                                                    This field may also be manually adjusted if needed. Date cannot be set prior to the current day.</p>
                                            </IconAlert>
                                        </div>
                                    </div>
                                </Row>
                                <div className="border-bottom border-dashed my-3"></div>

                                <Row className="g-3">
                                    <Form.Group as={Col}>
                                        <FloatingLabel as={Col} lg={12}
                                            label="Compliance comments"
                                            className='h6 fw-bold fs-5'
                                        >
                                            <Form.Control
                                                style={{ minHeight: "150px" }}
                                                type="text"
                                                as="textarea"
                                                rows={5}
                                                value={formData.ComplianceComment}
                                                onChange={handleFieldChange}
                                                id="ComplianceComment"
                                            />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Row>

                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <UploadFormFiles
                attachmentsData={attachmentsData}
                attachmentKinds={attachmentKind}
                setAttachmentsData={setAttachmentsData}
                uploadTo={"client-" + searchParams.get("id")}
            />
            <Col lg={12} className='mt-3 mb-3 g-3'>
                <Card>
                    <Card.Header className="bg-white">
                        <h5>Comments</h5>
                    </Card.Header>
                    <Card.Body className="bg-light">
                        <Form.Group as={Col}>
                            <Form.Control
                                style={{ minHeight: "150px" }}
                                type="text"
                                as="textarea"
                                rows={5}
                                value={formData.notes}
                                onChange={handleFieldChange}
                                id="notes"
                            />
                        </Form.Group>
                    </Card.Body>
                </Card>
            </Col>
        </>
    );
}

export default EditClientForm;
